import { render, staticRenderFns } from "./T3d-model-documents.component.vue?vue&type=template&id=363cc5f0"
import script from "./T3d-model-documents.component.ts?vue&type=script&lang=ts&external"
export * from "./T3d-model-documents.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('363cc5f0')) {
      api.createRecord('363cc5f0', component.options)
    } else {
      api.reload('363cc5f0', component.options)
    }
    module.hot.accept("./T3d-model-documents.component.vue?vue&type=template&id=363cc5f0", function () {
      api.rerender('363cc5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/T3d-model-documents/T3d-model-documents.component.vue"
export default component.exports